import { providers } from "ethers";

const ALCHEMY_ID = process.env.REACT_APP_ALCHEMY_ID;

export const mainNetProvider = new providers.JsonRpcProvider(`https://eth-mainnet.alchemyapi.io/v2/${ALCHEMY_ID}`);
export const polygonProvider = new providers.JsonRpcProvider(`https://polygon-mainnet.g.alchemy.com/v2/${ALCHEMY_ID}`);
export const optimismProvider = new providers.JsonRpcProvider(`https://opt-mainnet.g.alchemy.com/v2/${ALCHEMY_ID}`);
export const allProviders: {
  [chainId: number]: providers.JsonRpcProvider
} = {
  [1]: mainNetProvider,
  [10]: optimismProvider,
  [137]: polygonProvider,
}